module.exports = __webpack_public_path__ + "img/profile@2x.8e1cde1.webp";